import { type FC } from "react";

import { Button } from "@snapchat/snap-design-system";

import warning from "../../assets/common/warning.svg";

import { Flexbox } from "../../core/components";

import { Description, ErrorInfoCard, ErrorTitle, FullPageErrorContainer } from "./FullPageError.styles";

export const FullPageError: FC = () => (
    <FullPageErrorContainer alignItems="center" justifyContent="center">
        <ErrorInfoCard titleBorder={false}>
            <Flexbox alignItems="center" flexDirection="column">
                <img src={warning} />
                <ErrorTitle>Error</ErrorTitle>
                <Description>Connection lost. Please refresh the page and try again.</Description>
                <Button type="primary" href="/">
                    Refresh Page
                </Button>
            </Flexbox>
        </ErrorInfoCard>
    </FullPageErrorContainer>
);
